import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c61ef7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from 'vue'
import { useDisplay } from 'vuetify'
import { themedSettings } from '@/plugins/vuetify'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props) {

const display = useDisplay()
const getFooterWidth = computed(() => {
  return display.width
})

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_footer, {
      app: "",
      flat: "",
      absolute: "",
      color: "secondary",
      density: "compact",
      height: "230",
      class: _normalizeClass(
        getFooterWidth.value.value <= _unref(themedSettings).isMobileViewWidth
          ? 'xpadding-mobile'
          : getFooterWidth.value.value < _unref(themedSettings).maxWidth
          ? 'xpadding-other'
          : 'xpadding-responsive'
      )
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Adress: "),
        _hoisted_2,
        _createTextVNode("Leverantörsvägen 2 "),
        _hoisted_3,
        _createTextVNode(" 187 66 Täby "),
        _createVNode(_component_v_spacer),
        _createTextVNode("Kontakt: "),
        _hoisted_4,
        _createTextVNode("info@westro.se"),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})